import { useTranslation } from "react-i18next";
import PinnedVideoScene, { SceneSlide } from "./PinnedVideoScene";
import Navigation from "@components/Navigation";
import EzyConnectWidget from "@components/ezy/EzyConnectWidget";
import LandingSections from "./LandingSections";
import "./LandingPageV2.scss";

function SceneCta({ label }: { label: string }) {
  return (
    <button
      type="button"
      className="lpv2-cta"
      onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
    >
      {label}
    </button>
  );
}

export default function LandingPageV2() {
  const { t } = useTranslation("landing");

  const heroSlides: SceneSlide[] = [
    {
      from: -0.1,
      to: 0.36,
      node: (
        <>
          <h2>{t("hero.slide1.title")}</h2>
          <p>{t("hero.slide1.desc")}</p>
          <SceneCta label={t("hero.cta")} />
        </>
      ),
    },
    {
      from: 0.34,
      to: 0.66,
      node: (
        <>
          <h2>{t("hero.slide2.title")}</h2>
          <p>{t("hero.slide2.desc")}</p>
          <SceneCta label={t("hero.cta")} />
        </>
      ),
    },
    {
      from: 0.64,
      to: 1.1,
      node: (
        <>
          <h2>{t("hero.slide3.title")}</h2>
          <p>{t("hero.slide3.desc")}</p>
          <SceneCta label={t("hero.cta")} />
        </>
      ),
    },
  ];

  const sessionSlides: SceneSlide[] = [
    {
      from: -0.1,
      to: 0.36,
      node: (
        <>
          <h2>{t("session.slide1.title")}</h2>
          <p>{t("session.slide1.desc")}</p>
        </>
      ),
    },
    {
      from: 0.34,
      to: 0.66,
      node: (
        <>
          <h2>{t("session.slide2.title")}</h2>
          <p>{t("session.slide2.desc")}</p>
        </>
      ),
    },
    {
      from: 0.64,
      to: 1.1,
      node: (
        <>
          <h2>{t("session.slide3.title")}</h2>
          <p>{t("session.slide3.desc")}</p>
        </>
      ),
    },
  ];

  return (
    <div className="lpv2">
      <EzyConnectWidget />
      <Navigation variant="landing" />

      <PinnedVideoScene
        src="/media/hero-clinical.mp4"
        poster="/media/hero-clinical-poster.jpg"
        slides={heroSlides}
        ariaLabel={t("hero.ariaLabel")}
        align="top"
        playbackRate={0.5}
      />

      <PinnedVideoScene
        src="/media/hero-session.mp4"
        poster="/media/hero-session-poster.jpg"
        slides={sessionSlides}
        ariaLabel={t("session.ariaLabel")}
        align="bottom"
      />

      <div className="lp-root">
        <LandingSections />
      </div>
    </div>
  );
}
